(function () {
  'use strict';

  function initialize(root) {
    if (root.dataset.initialized) return;
    var grid = root.querySelector('.articles-grid');
    if (!grid) return;
    root.dataset.initialized = 'true';
    var cards = Array.from(grid.querySelectorAll('.article-card'));
    var ids = new Set(cards.map(function (card) { return card.dataset.articleId; }));
    var inputs = Array.from(root.querySelectorAll('.ca-search input'));
    var count = root.querySelector('[data-count]');
    var showing = root.querySelector('[data-showing]');
    var more = root.querySelector('[data-more]');
    var sort = root.querySelector('[data-sort]');
    var empty = root.querySelector('.ca-empty');
    var queryState = root.querySelector('.ca-query-state');
    var loadStatus = root.querySelector('[data-load-status]');
    var retry = root.querySelector('[data-retry]');
    var pagination = root.querySelector('[data-pagination]');
    var fallback = root.querySelector('[data-blog-fallback]');
    var filters = ['all', 'resin', 'fff', 'material', 'tips', 'new'];
    var pageSize = Number(root.dataset.pageSize) || 24;
    var current = 'all', shown = pageSize, query = '', ordered = [], filtered = [];
    var nextUrl = grid.dataset.nextUrl || '';
    var loading = false, failed = false;
    var controller = new AbortController();
    var visited = new Set();
    var initialUrl = new URL(window.location.href);
    // A native page-2 arrival must still be able to search articles on page 1.
    if (Number(grid.dataset.pageNumber) > 1) {
      var firstUrl = new URL(initialUrl);
      firstUrl.searchParams.delete(grid.dataset.pageParam || 'page');
      nextUrl = firstUrl.toString();
    }

    function norm(value) { return (value || '').normalize('NFKC').toLocaleLowerCase().trim(); }
    function number(card, key, otherwise) {
      var value = parseInt(card.dataset[key], 10);
      return Number.isFinite(value) ? value : otherwise;
    }
    function indexCard(card) {
      card.dataset.search = norm([
        card.querySelector('.article-title').textContent,
        card.querySelector('.article-excerpt').textContent
      ].join(' '));
      card.style.order = '';
    }
    cards.forEach(indexCard);
    function setQuery(value) {
      query = value;
      inputs.forEach(function (input) { if (input.value !== value) input.value = value; });
    }
    function reorder() {
      ordered = cards.slice().sort(function (a, b) {
        return sort.value === 'date'
          ? number(b, 'published', 0) - number(a, 'published', 0)
          : number(a, 'order', 9999) - number(b, 'order', 9999) || number(b, 'published', 0) - number(a, 'published', 0);
      });
      var fragment = document.createDocumentFragment();
      ordered.forEach(function (card) { fragment.appendChild(card); });
      grid.appendChild(fragment);
    }
    function render() {
      var words = norm(query).split(/\s+/).filter(Boolean);
      filtered = ordered.filter(function (card) {
        return (current === 'all' || (card.dataset.category || '').split(' ').includes(current)) &&
          words.every(function (word) { return card.dataset.search.includes(word); });
      });
      var visible = new Set(filtered.slice(0, shown));
      cards.forEach(function (card) { card.hidden = !visible.has(card); });
      var suffix = nextUrl ? '（読み込み済みの記事）' : '';
      count.textContent = filtered.length + '件中 ' + Math.min(shown, filtered.length) + '件を表示' + suffix;
      showing.textContent = filtered.length ? count.textContent : '';
      more.hidden = filtered.length <= shown;
      if (!more.hidden) more.textContent = 'もっと見る（次の' + Math.min(pageSize, filtered.length - shown) + '件）';
      // Do not claim there are no matches until the entire article list has arrived.
      empty.hidden = filtered.length !== 0 || Boolean(nextUrl);
      queryState.hidden = !query.trim() && current === 'all';
      root.querySelector('[data-query-label]').textContent = query.trim() || 'カテゴリで絞り込み中';
      root.querySelectorAll('[data-filter]').forEach(function (button) {
        var selected = button.dataset.filter === current;
        button.classList.toggle('active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      loadStatus.hidden = !nextUrl;
      loadStatus.textContent = failed
        ? '一部の記事を読み込めませんでした。再試行するか、ページ送りからご覧ください。'
        : '記事を読み込んでいます。読み込みに合わせて検索結果が増えることがあります。';
      retry.hidden = !failed;
      if (pagination) pagination.hidden = !nextUrl;
      if (fallback) fallback.hidden = !failed;
    }
    function updateUrl() {
      var url = new URL(window.location.href);
      if (current === 'all') url.searchParams.delete('category'); else url.searchParams.set('category', current);
      if (query.trim()) url.searchParams.set('q', query.trim()); else url.searchParams.delete('q');
      if (sort.value === 'date') url.searchParams.set('sort', 'date'); else url.searchParams.delete('sort');
      window.history.replaceState(null, '', url.toString());
    }
    function focusResults() {
      root.querySelector('[data-library-title]').focus();
      root.querySelector('[data-library]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    root.querySelectorAll('.ca-search').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault(); setQuery(form.querySelector('input').value); shown = pageSize;
        render(); updateUrl(); focusResults();
      });
    });
    inputs.forEach(function (input) {
      input.addEventListener('input', function () { setQuery(input.value); shown = pageSize; render(); updateUrl(); });
    });
    root.querySelectorAll('[data-query]').forEach(function (button) {
      button.addEventListener('click', function () {
        setQuery(button.dataset.query); current = 'all'; shown = pageSize;
        render(); updateUrl(); focusResults();
      });
    });
    root.querySelectorAll('[data-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        current = button.dataset.filter; shown = pageSize;
        if (current === 'new') sort.value = 'date';
        reorder(); render(); updateUrl();
      });
    });
    sort.addEventListener('change', function () { shown = pageSize; reorder(); render(); updateUrl(); });
    root.querySelectorAll('[data-reset]').forEach(function (button) {
      button.addEventListener('click', function () {
        setQuery(''); current = 'all'; sort.value = 'rank'; shown = pageSize;
        reorder(); render(); updateUrl(); focusResults();
      });
    });
    more.addEventListener('click', function () {
      var next = filtered[shown]; shown += pageSize; render();
      if (next) next.focus();
    });

    async function loadRemaining() {
      if (loading || !nextUrl) return;
      loading = true; failed = false; render();
      try {
        while (nextUrl) {
          if (root.isConnected === false) return;
          var url = new URL(nextUrl, initialUrl);
          if (url.origin !== initialUrl.origin || url.pathname !== initialUrl.pathname) throw new Error('Invalid article page');
          if (initialUrl.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', initialUrl.searchParams.get('preview_theme_id'));
          url.searchParams.set('section_id', root.dataset.sectionId);
          url.hash = '';
          var key = url.toString();
          if (visited.has(key)) throw new Error('Repeated article page');
          var response = await fetch(key, { credentials: 'same-origin', signal: controller.signal });
          if (!response.ok) throw new Error('Article page unavailable');
          var documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
          var incoming = Array.from(documentPage.querySelectorAll('[data-column-index]')).find(function (section) {
            return section.dataset.sectionId === root.dataset.sectionId;
          });
          var incomingGrid = incoming && incoming.querySelector('.articles-grid');
          if (!incomingGrid) throw new Error('Article list missing');
          var incomingCards = Array.from(incomingGrid.querySelectorAll('.article-card'));
          if (!incomingCards.length && Number(incomingGrid.dataset.articleTotal) > 0) throw new Error('Article page empty');
          if (incomingCards.some(function (card) {
            return !card.dataset.articleId || !card.querySelector('.article-title') || !card.querySelector('.article-excerpt');
          })) throw new Error('Article card incomplete');
          var incomingNextUrl = incomingGrid.dataset.nextUrl || '';
          var combinedIds = new Set(ids);
          incomingCards.forEach(function (card) { combinedIds.add(card.dataset.articleId); });
          if (!incomingNextUrl && combinedIds.size < Number(incomingGrid.dataset.articleTotal)) throw new Error('Article list incomplete');
          incomingCards.forEach(function (card) {
            if (!card.dataset.articleId || ids.has(card.dataset.articleId)) return;
            ids.add(card.dataset.articleId); indexCard(card); cards.push(card);
          });
          visited.add(key);
          nextUrl = incomingNextUrl;
          // Keep the native fallback pointing at the page not yet read.
          var nextLink = root.querySelector('[data-next-page]');
          if (nextLink && nextUrl) {
            var fallbackUrl = new URL(nextUrl, initialUrl);
            if (initialUrl.searchParams.has('preview_theme_id')) fallbackUrl.searchParams.set('preview_theme_id', initialUrl.searchParams.get('preview_theme_id'));
            nextLink.href = fallbackUrl.toString();
          }
          reorder(); render();
        }
      } catch (error) {
        if (error.name !== 'AbortError') failed = true;
      } finally {
        loading = false; render();
      }
    }
    retry.addEventListener('click', loadRemaining);
    root.addEventListener('sk-column-dispose', function () { controller.abort(); });
    var category = initialUrl.searchParams.get('category');
    current = filters.includes(category) ? category : 'all';
    sort.value = initialUrl.searchParams.get('sort') === 'date' || current === 'new' ? 'date' : 'rank';
    setQuery(initialUrl.searchParams.get('q') || '');
    reorder(); render(); loadRemaining();
  }

  function boot(scope) {
    if (scope.matches && scope.matches('[data-column-index]')) initialize(scope);
    scope.querySelectorAll('[data-column-index]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-column-index]').forEach(function (root) { root.dispatchEvent(new Event('sk-column-dispose')); });
  });
})();
